'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _theme = require('../../theme');

var _theme2 = _interopRequireDefault(_theme);

var _modal = require('../style/modal');

var _modal2 = _interopRequireDefault(_modal);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Main = function (_React$Component) {
    _inherits(Main, _React$Component);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        var root = props.root;

        _this.el = document.createElement('div');

        if (typeof root === 'string') {
            root = document.querySelector(root);
        }

        if (root instanceof HTMLElement) {
            _this.root = root;
        } else {
            _this.root = document.querySelector('body');
        }

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.root.appendChild(this.el);
            Main.instanceCount = isNaN(Main.instanceCount) ? 0 : Main.instanceCount;
            Main.instanceCount++;

            if (Main.instanceCount === 1) {
                this._rootFx('add');
            }

            return this;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.root.removeChild(this.el);

            if (!isNaN(Main.instanceCount)) {
                Main.instanceCount--;
            }

            if (Main.instanceCount === 0) {
                this._rootFx('remove');
            }

            return this;
        }
    }, {
        key: 'render',
        value: function render() {
            return _reactDom2.default.createPortal(this.props.children, this.el);
        }
    }, {
        key: '_rootFx',
        value: function _rootFx() {
            var _this2 = this;

            var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'add';

            var classList = _Component2.default.prototype.compileStyle.call(this, _modal2.default),
                className = classList.noScroll,
                siblingsClassName = classList.fx;

            if (this.root) {
                this.root.classList[method](className);
            }

            if (this.root && this.props.fx) {
                // сделано именно так, потому что IE11 не поддерживает методы NodeList
                var processor = function processor(node) {
                    if (node !== _this2.el && node instanceof HTMLElement && node.nodeName.toLowerCase() !== 'script') {
                        node.classList[method](siblingsClassName);
                    }
                };

                if (typeof this.root.childNodes.forEach === 'function') {
                    this.root.childNodes.forEach(processor);
                } else {
                    [].slice.call(this.root.childNodes).forEach(processor);
                }
            }

            return this;
        }
    }]);

    return Main;
}(_react2.default.Component);

Main.propTypes = {
    fx: _propTypes2.default.bool,
    root: _propTypes2.default.object,
    children: _propTypes2.default.any
};
Main.defaultProps = {
    fx: true
};
Main.displayName = 'Modal';
exports.default = (0, _theme2.default)(Main, 'modal');